"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Modal = require("@ccw-pwa-ui/Modal");
var _Input = require("@ccw-pwa-ui/Input");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
require("../styles/ForceChangePasswordStyle.css");
var _reactBootstrap = require("react-bootstrap");
var _bs = require("react-icons/bs");
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
var _helper = require("../common_features/utility/helper");
var _Button = require("@ccw-pwa-ui/Button");
var _Checkbox = require("@ccw-pwa-ui/Checkbox");
const ForceChangePasswordComponent = props => {
  // let {Button,Image,Header,HeaderText,Input,Checkbox} = Components
  // alert(props.hasMinLength)
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "force-change-password-screen"
  }, props.isSuccessModal ? /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: props.displayPasswordChangeModal,
    modalDetailText: props.modalDetailText,
    modalHeaderIcon: true,
    variant: "password-change-modal",
    positiveActionButtonTitle: props.continueButtonText,
    positiveAction: props.setDisplayPasswordChangeModal
  }) : null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    style: {
      maxWidth: 480,
      marginTop: _helper.headerHeight
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "change-password-screen-title"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "link-text",
    headerText: props.headerText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "change-password-input-wrapper"
  }, props.isSubTextVisible ? /*#__PURE__*/_react.default.createElement("div", {
    className: "email-screen-detail"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "simple-text",
    headerText: props.subText
  })) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "enter-password-container ".concat(props.errorMessage && props.isNewPasswordTouch ? "P-error" : "")
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333'
    },
    variant: "header-text",
    headerText: props.passwordText
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputStyle: {
      borderRadius: 10,
      marginTop: "10px"
    },
    placeholder: props.newPasswordPlaceholder,
    inputType: "password",
    value: props.newpassword,
    onchange: props.onChangeNewPassword,
    onBlur: props.handleNewPasswordBlur
  }), props.errorMessage && props.isNewPasswordTouch && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: "#E00932"
    }
  }, "Password does not meet requirements"), props.errorMessage && props.isNewPasswordTouch && /*#__PURE__*/_react.default.createElement("img", {
    src: _index.default.warning.default,
    alt: "",
    className: "input-warningIcon"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "change-password-validation"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      lineHeight: "22px"
    }
  }, /*#__PURE__*/_react.default.createElement(_bs.BsCheck, {
    style: {
      fontSize: 15,
      color: props.hasMinLength
    }
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400
    },
    variant: "simple-text",
    headerText: props.validationText1
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      lineHeight: "22px"
    }
  }, /*#__PURE__*/_react.default.createElement(_bs.BsCheck, {
    style: {
      fontSize: 15,
      color: props.hasOneUpperLowerCase
    }
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400
    },
    variant: "simple-text",
    headerText: props.validationText2
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      lineHeight: "22px"
    }
  }, /*#__PURE__*/_react.default.createElement(_bs.BsCheck, {
    style: {
      fontSize: 15,
      color: props.hasOneNumber
    }
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400
    },
    variant: "simple-text",
    headerText: props.validationText3
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      lineHeight: "22px"
    }
  }, /*#__PURE__*/_react.default.createElement(_bs.BsCheck, {
    className: "forceChangePassword",
    style: {
      color: props.hasSpecialChar
    }
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400
    },
    variant: "simple-text",
    headerText: props.validationText4
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "change-password-confirm-input-wrapper ".concat(props.conFirmErrorMessageFP ? "p2-error" : "")
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333'
    },
    variant: "header-text",
    headerText: props.confirmPassword
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputStyle: {
      borderRadius: 10,
      marginTop: "10px"
    },
    placeholder: props.confirmPasswordPlaceholder,
    inputType: "password",
    value: props.confirmNewPassword,
    onchange: props.onChangeConfirmNewPassword
  }), props.conFirmErrorMessageFP && /*#__PURE__*/_react.default.createElement("div", {
    className: "ErrorClass"
  }, "Passwords do not match"), props.conFirmErrorMessageFP && /*#__PURE__*/_react.default.createElement("img", {
    src: _index.default.warning.default,
    alt: "",
    className: "input-warningIcon2"
  })), props.isTermsVisible ? /*#__PURE__*/_react.default.createElement("div", {
    className: "change-password-terms"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginRight: 10
    },
    "data-testid": "chnagePasswordTermsCheckbox"
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.Checkbox, {
    checked: props.chnagePasswordTermsCheckbox,
    onChange: props.onChangePasswordTermsCheckbox
  })), /*#__PURE__*/_react.default.createElement("label", {
    style: {
      marginTop: '20px'
    }
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400
    },
    variant: "simple-text",
    headerText: props.termserviceText
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "forgot-password-text",
    headerText: props.termserviceText2,
    navigationUrl: props.termserviceTextUrl
  }))) : null, props.isTipsVisible ? /*#__PURE__*/_react.default.createElement("div", {
    className: "change-password-tips-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginRight: 10
    },
    "data-testid": "tipsAndTricksCheckbox"
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.Checkbox, {
    checked: props.tipsAndTricksCheckbox,
    onChange: props.onChangeTipsAndTricksCheckbox
  })), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      marginTop: '20px'
    },
    variant: "simple-text",
    headerText: props.tipsText
  })) : null, props.isPrivacyTextVisible ? /*#__PURE__*/_react.default.createElement("div", {
    className: "change-password-privacy-notice"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400
    },
    variant: "simple-text",
    headerText: props.privacyText
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      fontWeight: 700
    },
    variant: "forgot-password-text",
    headerText: props.privacyText2,
    navigationUrl: props.navigationUrl
  })) : null), /*#__PURE__*/_react.default.createElement("div", {
    className: "Change-password-button-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "change-password-button-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: props.buttonText,
    onClick: props.onClickContinue,
    disabled: !props.isContinueDisabled
  }))))), props.isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border"
  })) : null);
};
var _default = exports.default = ForceChangePasswordComponent;